import React, { useMemo, useState } from "react";
import { Alert, Box } from "@mui/material";

import DashboardShell from "../../../../components/DashboardShell";
import useClientDashboard from "../../../../hooks/useClientDashboard";
import clientDashboardNav from "./dashboardNav";
import BillingSection from "./sections/BillingSection";
import EngagementsSection from "./sections/EngagementsSection";
import OverviewSection from "./sections/OverviewSection";

const ClientDashboard = () => {
  const [activeSection, setActiveSection] = useState("overview");
  const dashboard = useClientDashboard();
  const {
    billingPagination,
    busyRateRequestIds,
    contracts,
    invoices,
    loading,
    message,
    navBadges,
    overview,
    payments,
    rateChangeAuditRequests,
    rateChangeRequests,
    generateContractMatches,
    requestCandidateInterview,
    recordInterviewOutcome,
    selectContractor,
    selectCandidateInterviewSlot,
    resolveContractRateChange,
    scheduledRateChanges,
    spending,
    submitPosition,
    updateContract,
    withdrawContract,
  } = dashboard;
  const sidebarItems = useMemo(
    () => clientDashboardNav.map((item) => ({ ...item, badge: navBadges?.[item.key] || 0 })),
    [navBadges]
  );

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <DashboardShell
        title="Client Workspace"
        items={sidebarItems}
        activeKey={activeSection}
        onSelect={setActiveSection}
        headerless
      >
        {message?.text && (
          <Alert severity={message.type || "info"} sx={{ mb: 2, textAlign: "left", borderRadius: 2 }}>
            {message.text}
          </Alert>
        )}
        {activeSection === "overview" && <OverviewSection overview={overview} />}
        {activeSection === "engagements" && (
          <EngagementsSection
            busyRateRequestIds={busyRateRequestIds}
            contracts={contracts}
            loading={loading}
            onGenerateMatches={generateContractMatches}
            onRequestInterview={requestCandidateInterview}
            onRecordInterviewOutcome={recordInterviewOutcome}
            onSelectContractor={selectContractor}
            onSelectInterviewSlot={selectCandidateInterviewSlot}
            onResolveRateChange={resolveContractRateChange}
            onSubmitPosition={submitPosition}
            onUpdateContract={updateContract}
            onWithdrawContract={withdrawContract}
            rateChangeAuditRequests={rateChangeAuditRequests}
            rateChangeRequests={rateChangeRequests}
            scheduledRateChanges={scheduledRateChanges}
            spending={spending}
          />
        )}
        {activeSection === "billing" && (
          <BillingSection
            invoices={invoices}
            loading={loading}
            payments={payments}
            {...billingPagination}
          />
        )}
      </DashboardShell>
    </Box>
  );
};

export default ClientDashboard;
